import { createFileRoute } from '@tanstack/react-router';
import { CampaignJourneysRouteView } from '@/pages/workspaces/automations/[campaignId]/journeys/routing';

function CampaignJourneysRoute() {
  const { campaignId } = Route.useParams();
  return <CampaignJourneysRouteView campaignId={campaignId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/journeys/',
)({
  component: CampaignJourneysRoute,
});
